import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isLoggedIn, logout } from "../utils/auth";
import { useCart } from "../context/CartContext";
// import CartSidebar from "../pages/CartPage";
import AuthModal from "./auth/AuthModal";
import { FaCartPlus } from "react-icons/fa";
import { FaCartShopping } from "react-icons/fa6";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);

  const [loggedIn, setLoggedIn] = useState(isLoggedIn());
  const [showAuth, setShowAuth] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { count} = useCart();

  useEffect(() => {
    const openLoginPopup = () => setShowAuth(true);

    window.addEventListener("open-login-popup", openLoginPopup);

    return () => window.removeEventListener("open-login-popup", openLoginPopup);
  }, []);

  useEffect(() => {
    const syncAuth = () => setLoggedIn(isLoggedIn());

    window.addEventListener("auth-change", syncAuth);
    return () => window.removeEventListener("auth-change", syncAuth);
  }, []);

  /* auto-close account dropdown after 3 sec */
  useEffect(() => {
    if (!accountOpen) return;
    const t = setTimeout(() => setAccountOpen(false), 3000);
    return () => clearTimeout(t);
  }, [accountOpen]);

  /* close hamburger on route change */
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    setMobileOpen(false);
    navigate("/");
  };

  return (
    <>
      {/* ================= DESKTOP HEADER ================= */}
      <header className="hidden lg:block bg-white border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto h-24 px-6 flex items-center">
          <Link to="/" className="mr-20">
            <img src="/image.png" alt="Confidays" className="h-16" />
          </Link>

          <nav className="flex-1">
            <ul className="flex justify-center gap-12 text-lg font-semibold">
              <NavItem to="/">Home</NavItem>
                 <NavItem to="/about">About us</NavItem>
              <NavItem to="/products">Products</NavItem>
              <NavItem to="/blog">Blog</NavItem>
              {/* <NavItem to="/careers">Careers</NavItem> */}
              {/* <NavItem to="/gallery">Gallery</NavItem> */}
              <NavItem to="/contact">Contact us</NavItem>
              <li className="relative flex items-center gap-2 cursor-pointer">
                <button
                onClick={() => navigate("/cart")}
                  className="relative flex items-center gap-2 font-semibold hover:text-brandPink "
                >
                  {/* ICON */}
                   <FaCartShopping className="w-4 h-4"/>
                  {/* TEXT */}
                  <span>Cart</span>

                  {/* BADGE */}
                  {count > 0 && (
                    <span className="absolute -top-2 -right-3 bg-red-600 text-white text-xs min-w-[18px] h-[18px] px-1 rounded-full flex items-center justify-center">
                      {count}
                    </span>
                  )}
                </button>
              </li>

              {!loggedIn ? (
                <button
                  onClick={() => setShowAuth(true)}
                  className="font-semibold hover:text-brandPink"
                >
                  Login
                </button>
              ) : (
                <div className="relative">
                  <button onClick={() => setAccountOpen((s) => !s)}>
                    Account ▾
                  </button>

                  {accountOpen && (
                    <div className="absolute right-0 mt-3 w-48 bg-white border shadow-md rounded">
                      <AccountLink to="/dashboard">Dashboard</AccountLink>

                      <button
                        onClick={handleLogout}
                        className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              )}
            </ul>
          </nav>
        </div>
      </header>

      {/* ================= MOBILE + TABLET HEADER ================= */}
      <header className="lg:hidden fixed top-0 left-0 right-0 bg-white border-b z-[9999]">
        <div className="flex items-center justify-between h-16 px-4">
          {/* Hamburger */}
          {/* <button
            onClick={() => setMobileOpen(true)}
            className="w-10 h-10 flex items-center justify-center"
          >
            <MenuIcon />
          </button> */}
          <button
  onClick={() => setMobileOpen((prev) => !prev)} // ✅ toggle not just open
  className="w-10 h-10 flex items-center justify-center"
>
  <MenuIcon />
</button>

          {/* Logo */}
          <Link to="/">
            <img src="/image.png" alt="Confidays" className="h-10" />
          </Link>

          <button
       onClick={() => navigate("/cart")}
            className="relative w-10 h-10 flex items-center justify-center mr-4"
          >
              <FaCartShopping className="w-4 h-4"/>
            {count > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] min-w-[18px] h-[18px] rounded-full flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
        </div>
      </header>

     
      {/* ================= MOBILE DRAWER ================= */}
{mobileOpen && (
  <div className="fixed inset-0 z-50 flex">

<div
  className="w-72 h-full text-black relative overflow-y-auto"
  style={{
    background: "#ffffff",
    boxShadow: "4px 0 24px rgba(0,0,0,0.08)",
  }}
>
  {/* LOGO AREA */}
  <div
    style={{
      padding: "20px 24px 16px",
      borderBottom: "1px solid #f3f4f6",
      marginTop: "56px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    <span style={{ fontSize: "15px", fontWeight: "700", color: "#1A237E" }}>
      Menu
    </span>
    <button
      onClick={() => setMobileOpen(false)}
      style={{
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        background: "#f3f4f6",
        border: "none",
        fontSize: "14px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#666",
      }}
    >
      ✕
    </button>
  </div>

  {/* NAV LINKS */}
  <div style={{ padding: "8px 0" }}>
    <MobileLink to="/" close={setMobileOpen}>Home</MobileLink>
    <MobileLink to="/about" close={setMobileOpen}>About</MobileLink>
    <MobileLink to="/products" close={setMobileOpen}>Products</MobileLink>
    <MobileLink to="/blog" close={setMobileOpen}>Blog</MobileLink>
    <MobileLink to="/contact" close={setMobileOpen}>Contact</MobileLink>
  </div>

  <div style={{ height: "1px", background: "#f3f4f6", margin: "8px 24px" }} />

  {/* AUTH */}
  <div style={{ padding: "8px 0" }}>
    {!loggedIn ? (
      <button
        onClick={() => { setMobileOpen(false); setShowAuth(true); }}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
          padding: "14px 24px",
          background: "none",
          border: "none",
          fontSize: "15px",
          fontWeight: "600",
          color: "#EC4899",
          cursor: "pointer",
        }}
      >
        Login
      </button>
    ) : (
      <>
        <MobileLink to="/dashboard" close={setMobileOpen}>Dashboard</MobileLink>
        <MobileLink to="/dashboard/purchase-history" close={setMobileOpen}>Orders</MobileLink>
        <MobileLink to="/dashboard/addresses" close={setMobileOpen}>Address</MobileLink>
      
         <MobileLink to="/dashboard/track-orders" close={setMobileOpen}>Track Orders</MobileLink>
        <MobileLink to="/dashboard/payments" close={setMobileOpen}>Payments</MobileLink>
            <MobileLink to="/dashboard/profile" close={setMobileOpen}>Profile</MobileLink>
          
  
   
   
        <button
          onClick={handleLogout}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            width: "100%",
            padding: "14px 24px",
            background: "none",
            border: "none",
            fontSize: "15px",
            fontWeight: "600",
            color: "#ef4444",
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </>
    )}
  </div>
</div>

    {/* OVERLAY — RIGHT SIDE */}
    <div
      className="flex-1 bg-black/40"
      onClick={() => setMobileOpen(false)}
    />
  </div>
)}

      {/* ================= CART SIDEBAR ================= */}
      {/* {cartOpen && <CartSidebar open={cartOpen} onClose={closeCart} />} */}
      {/* {cartOpen && <CartSidebar onClose={closeCart} />} */}
      <AuthModal isOpen={showAuth} onClose={() => setShowAuth(false)} />
    </>
  );
}

/* ================= HELPERS ================= */

function NavItem({ to, children }) {
  return <Link to={to}>{children}</Link>;
}

// function MobileLink({ to, children, close }) {
//   return (
//     <Link to={to} onClick={() => close(false)} className="block py-3 text-lg">
//       {children}
//     </Link>
//   );
// }



function MobileLink({ to, children, close }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link
      to={to}
      onClick={() => close(false)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "14px 24px",
        fontSize: "15px",
        fontWeight: isActive ? "600" : "400",
        color: isActive ? "#1A237E" : "#374151",
        textDecoration: "none",
        borderBottom: "1px solid #f9fafb",
        background: isActive ? "#f0f3ff" : "transparent",
        transition: "background 0.2s",
      }}
    >
      {/* RADIO CIRCLE */}
      <span
        style={{
          width: "18px",
          height: "18px",
          borderRadius: "50%",
          border: isActive ? "5px solid #EC4899" : "2px solid #d1d5db",
          flexShrink: 0,
          transition: "border 0.2s",
        }}
      />
      {children}
    </Link>
  );
}

function AccountLink({ to, children }) {
  return (
    <Link to={to} className="block px-4 py-2 hover:bg-gray-100">
      {children}
    </Link>
  );
}

/* ================= ICONS ================= */

function MenuIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 24 24"
      stroke="black"
      fill="none"
      strokeWidth="2.5"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

function CartIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      stroke="black"
      fill="none"
      strokeWidth="2"
    >
      <path d="M6 6h15l-2 9H7L6 6z" />
      <circle cx="9" cy="21" r="1" />
      <circle cx="18" cy="21" r="1" />
    </svg>
  );
}
